var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoMastercard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 112,
    height: 56,
    viewBox: "0 0 112 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5219",
    "data-name": "Rectangle 5219",
    width: 112,
    height: 56,
    transform: "translate(1295 735)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo_Mastercard",
    transform: "translate(-1295 -735)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mc_vrt_rev",
    transform: "translate(1308.417 727.879)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5181",
    "data-name": "Rectangle 5181",
    width: 85.635,
    height: 70.242,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_24624",
    "data-name": "Group 24624",
    transform: "translate(8.84 8.841)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54708",
    "data-name": "Path 54708",
    d: "M352.628,345.469v-3.5a2.076,2.076,0,0,0-2.193-2.216,2.16,2.16,0,0,0-1.96.992,2.048,2.048,0,0,0-1.843-.992,1.844,1.844,0,0,0-1.633.828v-.688h-1.213v5.576h1.225v-3.091a1.3,1.3,0,0,1,1.365-1.481c.8,0,1.213.525,1.213,1.47v3.1h1.225v-3.091a1.315,1.315,0,0,1,1.365-1.481c.828,0,1.225.525,1.225,1.47v3.1Zm18.128-5.576h-1.983V338.2h-1.225v1.691h-1.132V341h1.132v2.543c0,1.295.5,2.065,1.936,2.065a2.85,2.85,0,0,0,1.516-.432l-.35-1.038a2.24,2.24,0,0,1-1.073.315c-.607,0-.8-.373-.8-.933V341h1.983Zm10.347-.14a1.645,1.645,0,0,0-1.47.817v-.677h-1.2v5.576h1.213v-3.126c0-.921.4-1.435,1.19-1.435a1.976,1.976,0,0,1,.758.14l.373-1.143A2.6,2.6,0,0,0,381.1,339.753Zm-15.643.583a4.171,4.171,0,0,0-2.275-.583c-1.412,0-2.321.677-2.321,1.785,0,.91.677,1.47,1.925,1.645l.572.082c.665.093.98.268.98.583,0,.432-.443.677-1.271.677a2.97,2.97,0,0,1-1.855-.583l-.572.945a4.023,4.023,0,0,0,2.415.723c1.61,0,2.543-.758,2.543-1.82,0-.98-.735-1.493-1.948-1.668l-.571-.082c-.525-.07-.945-.175-.945-.548,0-.408.4-.653,1.062-.653a3.6,3.6,0,0,1,1.738.478Zm32.5-.583a1.645,1.645,0,0,0-1.47.817v-.677h-1.2v5.576H396.5v-3.126c0-.921.4-1.435,1.19-1.435a1.976,1.976,0,0,1,.758.14l.373-1.143A2.6,2.6,0,0,0,397.958,339.753Zm-15.631,2.928a2.817,2.817,0,0,0,2.975,2.928,2.921,2.921,0,0,0,2.006-.665l-.583-.98a2.451,2.451,0,0,1-1.458.5,1.788,1.788,0,0,1,0-3.57,2.451,2.451,0,0,1,1.458.5l.583-.98a2.921,2.921,0,0,0-2.006-.665,2.817,2.817,0,0,0-2.975,2.928Zm11.362,0v-2.788h-1.213v.676a2.116,2.116,0,0,0-1.761-.817,2.932,2.932,0,0,0,0,5.856,2.116,2.116,0,0,0,1.761-.817v.677h1.213Zm-4.514,0a1.673,1.673,0,1,1,.455,1.263A1.688,1.688,0,0,1,389.174,342.681Zm-14.64-2.928a2.93,2.93,0,0,0,.082,5.856,3.389,3.389,0,0,0,2.286-.782l-.6-.9a2.656,2.656,0,0,1-1.621.583,1.549,1.549,0,0,1-1.668-1.365h4.141c.012-.152.023-.3.023-.467A2.673,2.673,0,0,0,374.535,339.753Zm-.023,1.085a1.385,1.385,0,0,1,1.411,1.353H373.03a1.436,1.436,0,0,1,1.481-1.353Zm30.434,1.843v-5.027h-1.213v2.916a2.116,2.116,0,0,0-1.761-.817,2.931,2.931,0,0,0,0,5.856,2.115,2.115,0,0,0,1.761-.817v.677h1.213Zm2.022,1.98a.557.557,0,0,1,.22.043.571.571,0,0,1,.179.119.56.56,0,0,1,.121.177.545.545,0,0,1,0,.43.564.564,0,0,1-.121.176.58.58,0,0,1-.179.119.547.547,0,0,1-.22.044.565.565,0,0,1-.523-.34.546.546,0,0,1,0-.43.564.564,0,0,1,.12-.177.557.557,0,0,1,.18-.119.575.575,0,0,1,.223-.044Zm0,.986a.413.413,0,0,0,.167-.034.44.44,0,0,0,.136-.092.432.432,0,0,0-.136-.7.419.419,0,0,0-.167-.033.436.436,0,0,0-.17.033.424.424,0,0,0-.138.092.432.432,0,0,0,.138.7A.428.428,0,0,0,406.968,345.647Zm.033-.691a.235.235,0,0,1,.153.044.148.148,0,0,1,.054.12.14.14,0,0,1-.043.105.2.2,0,0,1-.122.051l.168.194h-.132l-.156-.193h-.05v.193h-.11v-.515Zm-.128.1v.137H407a.124.124,0,0,0,.069-.017.058.058,0,0,0,.026-.052.057.057,0,0,0-.026-.051.125.125,0,0,0-.069-.017Zm-6.442-2.371a1.673,1.673,0,1,1,.455,1.263A1.688,1.688,0,0,1,400.431,342.681Zm-40.968,0v-2.788H358.25v.676a2.115,2.115,0,0,0-1.761-.817,2.932,2.932,0,0,0,0,5.856,2.116,2.116,0,0,0,1.761-.817v.677h1.213Zm-4.514,0a1.673,1.673,0,1,1,.455,1.263A1.688,1.688,0,0,1,354.949,342.681Z",
    transform: "translate(-340.267 -292.909)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_24623",
    "data-name": "Group 24623"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5182",
    "data-name": "Rectangle 5182",
    width: 18.375,
    height: 33.02,
    transform: "translate(24.79 4.49)",
    fill: "#969696"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54709",
    "data-name": "Path 54709",
    d: "M363.71,281.949a20.964,20.964,0,0,1,8.021-16.51,21,21,0,1,0,0,33.02A20.964,20.964,0,0,1,363.71,281.949Z",
    transform: "translate(-337.753 -260.949)",
    fill: "#5c5c5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54710",
    "data-name": "Path 54710",
    d: "M429.976,281.949A21,21,0,0,1,396,298.46a21,21,0,0,0,0-33.02,21,21,0,0,1,33.976,16.51Z",
    transform: "translate(-362.023 -260.949)",
    fill: "#bfbfbf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54711",
    "data-name": "Path 54711",
    d: "M450.509,318.674V318h.273v-.138h-.694V318h.273v.676Zm1.348,0v-.815h-.213l-.245.561-.245-.561h-.213v.815h.15v-.615l.23.53h.156l.23-.531v.616Z",
    transform: "translate(-384.559 -284.662)",
    fill: "#f79e1b"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMastercard);
export default __webpack_public_path__ + "static/media/Logo_Mastercard.cfde8c9c4dab9b164c9590a507567f12.svg";
export { ForwardRef as ReactComponent };